import { z } from 'zod';

export enum LookbackDurationUnit {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export const LookbackDurationSchema = z.object({
  value: z.coerce.number().min(0, { message: 'Duration value cannot be negative' }),
  unit: z.enum(LookbackDurationUnit, { message: 'Unit reqd' }),
});
export type LookbackDuration = z.infer<typeof LookbackDurationSchema>;
